
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 331c-8.276 0-15 6.724-15 15s6.724 15 15 15 15-6.724 15-15-6.724-15-15-15z"}}),_c('path',{attrs:{"d":"M256 271c-41.353 0-75 33.647-75 75s33.647 75 75 75 75-33.647 75-75-33.647-75-75-75zm0 120c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45zM256 91c-24.814 0-45 20.186-45 45s20.186 45 45 45 45-20.186 45-45-20.186-45-45-45zm15 60h-30v-30h30v30z"}}),_c('path',{attrs:{"d":"M91 0v512h330V0H91zm165 61c41.353 0 75 33.647 75 75s-33.647 75-75 75-75-33.647-75-75 33.647-75 75-75zm0 390c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105z"}})])
          )
        }
      }
    